<template>
  <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800 p-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
    
    <div class="prose dark:prose-invert max-w-none">
      <p class="mb-4">Last updated: {{ new Date().toLocaleDateString() }}</p>
      
      <h2 class="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
      <p>We collect information that you provide directly to us, including:</p>
      <ul class="list-disc pl-6 mb-4">
        <li>Name and contact information</li>
        <li>Account credentials</li>
        <li>Payment information</li>
        <li>Business information</li>
      </ul>

      <h2 class="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul class="list-disc pl-6 mb-4">
        <li>Provide and maintain our services</li>
        <li>Process your transactions</li>
        <li>Send you technical notices and support messages</li>
        <li>Communicate with you about products, services, and events</li>
      </ul>

      <h2 class="text-2xl font-semibold mt-8 mb-4">3. Information Sharing</h2>
      <p>We do not sell your personal information. We may share your information with:</p>
      <ul class="list-disc pl-6 mb-4">
        <li>Service providers</li>
        <li>Business partners</li>
        <li>Law enforcement when required</li>
      </ul>

      <h2 class="text-2xl font-semibold mt-8 mb-4">4. Your Rights</h2>
      <p>You have the right to:</p>
      <ul class="list-disc pl-6 mb-4">
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Opt-out of marketing communications</li>
      </ul>
    </div>
  </div>
</template>